import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MaintenanceState {
  isMaintenanceMode: boolean;
}

const initialState: MaintenanceState = {
  isMaintenanceMode: false,
};

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.isMaintenanceMode = action.payload;
    },
  },
});

export const { setMaintenanceMode } = maintenanceSlice.actions;
export default maintenanceSlice.reducer;
